import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-sm text-red-500"
}
const _hoisted_2 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_3 = { class: "flex flex-col gap-1 text-sm" }
const _hoisted_4 = { class: "flex flex-col gap-1 text-sm" }
const _hoisted_5 = { class: "grid grid-cols-1 md:grid-cols-2 gap-4" }
const _hoisted_6 = { class: "flex flex-col gap-1 text-sm" }
const _hoisted_7 = { class: "flex flex-col gap-1 text-sm" }
const _hoisted_8 = { class: "flex items-center gap-2 text-sm" }
const _hoisted_9 = { class: "flex gap-3" }
const _hoisted_10 = ["disabled"]

import type { DevRoeLocation } from '#shared/lex'
import type { Strict } from '#shared/cms/strict'

type LocationValue = Omit<Strict<DevRoeLocation.Record>, '$type'>


export default /*@__PURE__*/_defineComponent({
  __name: 'LocationForm',
  props: {
    initial: {}
  },
  emits: ["submit"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const form = reactive({
  city: props.initial?.city ?? '',
  region: props.initial?.region ?? '',
  country: props.initial?.country ?? '',
  countryCode: props.initial?.countryCode ?? '',
  meetupAvailable: props.initial?.meetupAvailable ?? true,
})

const submitting = ref(false)
const error = ref<string | null>(null)

async function onSubmit () {
  error.value = null
  submitting.value = true
  try {
    const value: LocationValue = {
      city: form.city,
      ...(form.region ? { region: form.region } : {}),
      country: form.country,
      countryCode: form.countryCode.toUpperCase(),
      meetupAvailable: form.meetupAvailable,
      ...(props.initial?.createdAt ? { createdAt: props.initial.createdAt } : { createdAt: new Date().toISOString() }),
    }
    emit('submit', value)
  }
  catch (err) {
    error.value = err instanceof Error ? err.message : String(err)
  }
  finally {
    submitting.value = false
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "flex flex-col gap-4 max-w-lg",
    onSubmit: _withModifiers(onSubmit, ["prevent"])
  }, [
    (_unref(error))
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_unref(error)), 1))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("label", _hoisted_3, [
        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-muted" }, [
          _createTextVNode("City "),
          _createElementVNode("span", { class: "text-red-500" }, "*")
        ], -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(form).city) = $event)),
          required: "",
          type: "text",
          class: "bg-accent px-3 py-2"
        }, null, 512), [
          [_vModelText, _unref(form).city]
        ])
      ]),
      _createElementVNode("label", _hoisted_4, [
        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "text-muted" }, "Region / state", -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(form).region) = $event)),
          type: "text",
          class: "bg-accent px-3 py-2"
        }, null, 512), [
          [_vModelText, _unref(form).region]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("label", _hoisted_6, [
        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "text-muted" }, [
          _createTextVNode("Country "),
          _createElementVNode("span", { class: "text-red-500" }, "*")
        ], -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(form).country) = $event)),
          required: "",
          type: "text",
          class: "bg-accent px-3 py-2"
        }, null, 512), [
          [_vModelText, _unref(form).country]
        ])
      ]),
      _createElementVNode("label", _hoisted_7, [
        _cache[8] || (_cache[8] = _createElementVNode("span", { class: "text-muted" }, [
          _createTextVNode("Country code (ISO 2-letter) "),
          _createElementVNode("span", { class: "text-red-500" }, "*")
        ], -1)),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(form).countryCode) = $event)),
          required: "",
          type: "text",
          minlength: "2",
          maxlength: "2",
          pattern: "[A-Za-z]{2}",
          class: "bg-accent px-3 py-2 uppercase"
        }, null, 512), [
          [_vModelText, _unref(form).countryCode]
        ])
      ])
    ]),
    _createElementVNode("label", _hoisted_8, [
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(form).meetupAvailable) = $event)),
        type: "checkbox"
      }, null, 512), [
        [_vModelCheckbox, _unref(form).meetupAvailable]
      ]),
      _cache[9] || (_cache[9] = _createElementVNode("span", null, "Available for meetups", -1))
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createElementVNode("button", {
        type: "submit",
        disabled: _unref(submitting),
        class: "bg-primary text-background px-4 py-2 hover:bg-primary/90 transition-colors disabled:opacity-60"
      }, _toDisplayString(_unref(submitting) ? 'Saving…' : 'Save'), 9, _hoisted_10)
    ])
  ], 32))
}
}

})